<template>
  <nuttrema-layout-west-slide width="100%">
    <west-slide-left-navigation slot="navigation-top">
      <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white" @click="onCancelEvent"></nuttrema-iconica-sidebar-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <nuttrema-layout-content>
      <template slot="header">
        <instance-standard-header
          :edit="false"
          :showEdit="false"
          :meta="meta"
          :InstanceDetails="InstanceDetails">
        </instance-standard-header>
        <nuttrema-layout-content-header theme="registration-steps">
          <el-steps :active="activeStep" finish-status="success" simple>
            <el-step>
              <span slot="title">{{ $t('label.select_plan')}}
                <template v-if="activeStep !== 0"><a @click="goto('instance-subscription-purchase-new-select-plan')">({{ $t('label.change') | lowercase }})</a></template>
              </span>
            </el-step>
            <el-step :title="$t('label.review_and_checkout')"></el-step>
            <el-step :title="$t('label.thank_you')"></el-step>
          </el-steps>
        </nuttrema-layout-content-header>
      </template>

      <router-view slot="central"></router-view>

    </nuttrema-layout-content>

  </nuttrema-layout-west-slide>
</template>

<script>
import { get } from 'lodash';
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import InstanceStandardHeader from 'components/pages/professional/instance/shared/cmpt-instance-standard-header';
import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';

export default {
  name: 'page-instance-purchase-new',
  mixins: [PageProps],
  components: {
    NuttremaLayoutContent,
    InstanceStandardHeader,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutContentHeader,
    NuttremaLayoutWestThreeVertical,
  },
  data() {
    return {
      edit: true,
    };
  },
  computed: {
    InstanceDetails() {
      return this.$store.getters.InstanceDetails;
    },
    activeStep() {
      const route = get(this.$route, 'name', null);
      switch (route) {
        case 'instance-subscription-purchase-new-select-plan':
          return 0;
        case 'instance-subscription-purchase-new-review-and-checkout':
          return 1;
        case 'instance-subscription-purchase-new-thank-you':
          return 2;
        default:
          return 0;
      }
    },
  },
  methods: {
    goto(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>

<style lang="scss" scoped>
  $color-is-link: #607d8b;
  $color-is-success: #2196f3;
  // $color-is-process: #00afab;
  $color-is-process: #ff9800;

  /deep/ .el-steps.el-steps--simple {
    .el-step {
      .el-step__head {

        &.is-success {
          .el-step__icon.is-text {
            width: 22px;
            height: 22px;
            font-size: 14px;
          }
        }

        &.is-success {
          color: $color-is-success;
          border-color: $color-is-success;
        }
        &.is-process {
          color: $color-is-process;
          border-color: $color-is-process;
        }
      }

      .el-step__main {
        .el-step__title {
          a {
            color: $color-is-link;
            &:hover {
              color: darken($color-is-link, 10%);
            }
          }
          &.is-success {
            color: $color-is-success;
            border-color: $color-is-success;
          }
          &.is-process {
            color: $color-is-process;
            border-color: $color-is-process;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/subscriptions/purchase-new/page-instance-purchase-new.vue